import { Button } from '@cokitchen/cokitchen-components';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { KITCHEN_ROUTE_KEYS } from 'utils/constants';

const EditReviewFooter = ({
  onConfirm,
  loading,
  disabled,
  start_date,
  end_date
}: {
  onConfirm?: () => void;
  loading?: boolean;
  disabled?: boolean;
  start_date: string | null;
  end_date: string | null;
}) => {
  const navigate = useNavigate();

  const handleCancel = () =>
    navigate(`${KITCHEN_ROUTE_KEYS.WEEKLY_ROSTER}?start_date=${start_date}&end_date=${end_date}`);
  return (
    <footer className='p-8 bg-white rounded-b-xl border-b border-x border-[#F5F5F5] flex items-center justify-end gap-6'>
      <Button
        small
        color='primary'
        variant='outline'
        className='max-w-[220px] !bg-[#F0F0F0] !border-0 !text-[#1A1A1A]'
        onClick={handleCancel}>
        Cancel
      </Button>
      <Button
        small
        color='primary'
        variant='block'
        className='max-w-[220px]'
        onClick={onConfirm}
        loading={loading}
        disabled={disabled}>
        Confirm
      </Button>
    </footer>
  );
};

export default EditReviewFooter;
